module.exports = __webpack_public_path__ + "static/img/routing_needed.040d8aea.svg";